import React, { useMemo, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { useNavigate, useLocation } from "react-router-dom";
import CalenderSVG from "assets/logo/Calendar";

const tableData = [
    {
        id: 1,
        company: "JMCC",
        subRows: [
            {
                id: "1.1",
                building: "Admin & Cost Building",
                subRows: [
                    {
                        id: "1.1.1",
                        activity: "Exacavation",
                    },
                    {
                        id: "1.1.2",
                        activity: "RCC of Foundation",
                    },
                    {
                        id: "1.1.3",
                        activity: "BOLT FIXING",
                    },
                ],
            },
            {
                id: "1.2",
                building: "Canteen Building",
                subRows: [
                    {
                        id: "1.2.1",
                        activity: "",
                    },
                    {
                        id: "1.2.2",
                        activity: "",
                    },
                    {
                        id: "1.2.3",
                        activity: "",
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        company: "PN Construction",
        subRows: [
            {
                id: "2.1",
                building: "Pre-Cast Boundary Wall",
                subRows: [
                    {
                        id: "2.1.1",
                        activity: "Excavation",
                    },
                    {
                        id: "2.1.2",
                        activity: "RCC OF FOUNDATION",
                    },
                    {
                        id: "2.1.3",
                        activity: "RCC OF PEDESTAL",
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        company: "Swanil Engineering",
        subRows: [
            {
                id: "3.1",
                building: "Drainage System/ Nala Boundary Wall",
                subRows: [
                    {
                        id: "3.1.1",
                        activity: "EXCAVATION",
                    },
                    {
                        id: "3.1.2",
                        activity: "RCC OF FOUNDATION",
                    },
                    {
                        id: "3.1.3",
                        activity: "RCC OF PEDESTAL",
                    },
                ],
            },
            {
                id: "3.2",
                building: "Boundary Wall in common Region",
                subRows: [
                    {
                        id: "3.2.1",
                        activity: "EXCAVATION",
                    },
                    {
                        id: "3.2.2",
                        activity: "RCC OF FOUNDATION",
                    },
                    {
                        id: "3.2.3",
                        activity: "RCC OF PEDESTAL",
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        company: "MS Engineering",
        subRows: [
            {
                id: "4.1",
                building: "Admin & Cost Building",
                subRows: [
                    {
                        id: "4.1.1",
                        activity: "Exacavation",
                    },
                    {
                        id: "4.1.2",
                        activity: "RCC of Foundation",
                    },
                    {
                        id: "4.1.3",
                        activity: "BOLT FIXING",
                    },
                ],
            },
            {
                id: "4.2",
                building: "Canteen Building",
                subRows: [
                    {
                        id: "4.2.1",
                        activity: "",
                    },
                    {
                        id: "4.2.2",
                        activity: "",
                    },
                    {
                        id: "4.2.3",
                        activity: "",
                    },
                ],
            },
        ],
    },
];

function ViewMonthlyPlan() {

    const location = useLocation();
    const { month } = location.state || {};
    const navigate = useNavigate();
    const [data, setData] = useState(tableData);

    const currentMonthName = new Date().toLocaleString("default", { month: "long" });

    const isCurrentMonth = () => {

        if (!month) return false;
        const normalized = month.toString().toLowerCase();
        return (
            normalized === currentMonthName.toLowerCase()
        );
    };

    const renderTextFieldCell = (dayKey) => ({ row, table }) => {

        if (!row.original.activity) return null;
        if (!isCurrentMonth()) return null;
        return (
            <input
                type="text"
                value={row.original[dayKey] || ""}
                onChange={(e) => {
                    const newValue = e.target.value;
                    row.original[dayKey] = newValue;
                    table.options.meta?.updateData(row.index, dayKey, newValue);
                }}
                style={{
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "4px 6px",
                    fontSize: "13px",
                }}
            />
        );
    };

    const dayColumns = Array.from({ length: 31 }, (_, i) => {
        const day = `day${i + 1}`;
        return { accessorKey: day, header: `Day ${i + 1}`, size: 60, Cell: renderTextFieldCell(day) };
    });

    const columns = useMemo(
        () => [

            {
                header: "Details",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: [
                    { accessorKey: 'company', header: 'Level 1', size: 150 },
                    { accessorKey: 'building', header: 'Level 2', size: 150 },
                    { accessorKey: 'activity', header: 'Activity', size: 150 },
                ]
            },

            {
                header: "Month Days",
                muiTableHeadCellProps: {
                    sx: {
                        backgroundColor: "#E3F2FD",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #DADADA",
                    },
                },
                columns: dayColumns,
            },
        ],
        [dayColumns]
    );

    return (
        <Box
            sx={{
                flexGrow: 1,
                width: "100%",
                overflowX: "auto",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    mt: 3,
                    p: { xs: 1, sm: 2 },
                    width: "100%",
                    //maxWidth: 1290,
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        mb: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            mb: 1,
                        }}
                    >
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: "#5F5F5F" }}>
                            View Monthly Plan
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                            <Typography sx={{ mb: 1, fontWeight: 600, color: "#84919A", fontSize: "16px" }}>Month: </Typography>
                            <Typography sx={{ fontWeight: 400, color: "#84919A", fontSize: "14px", pt: "2px" }}> {month}</Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            mt: 4,
                        }}
                    >
                        <Button
                            onClick={() => navigate("/projects/10b9ff2d-8d78-44c4-96b4-26ba2cc35f13/dpr/monthly-plan")}
                            variant="contained"
                            sx={{
                                backgroundColor: "#00344C",
                                borderRadius: "25px",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                fontFamily: "Outfit, sans-serif",
                                color: "#FFFFFF",
                                px: "18px",
                                py: "12px",
                            }}
                        >
                            Back
                        </Button>
                    </Box>
                </Box>

                <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableExpanding
                    enableExpandAll
                    editingMode="cell"
                    initialState={{ expanded: false }}
                    enableFullScreenToggle={false}
                    meta={{
                        updateData: (rowIndex, columnId, value) => {
                            setData((prev) =>
                                prev.map((row, index) =>
                                    index === rowIndex ? { ...row, [columnId]: value } : row
                                )
                            );
                        },
                    }}
                    enableColumnPinning
                    initialState={{
                        columnPinning: { left: ["mrt-row-expand", "company", "building", "activity"] },
                    }}
                />

            </Box>
        </Box>
    );
}

export default ViewMonthlyPlan;